import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBuilding, faUsers, faChartPie } from '@fortawesome/free-solid-svg-icons';

const PracticeSummaryModal = ({ show, onClose, summary, practices }) => {
  if (!show) return null;

  return (
    <div className="dashboard-modal-overlay">
      <div className="dashboard-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <div className="modal-title-row">
              <FontAwesomeIcon icon={faBuilding} className="modal-title-icon" />
              <h3>Total Practices</h3>
            </div>
            <p className="modal-subtitle">Quick overview of active practices and current page results.</p>
          </div>
          <button type="button" className="close-btn" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="modal-body">
          <div className="summary-modal-cards">
            <div className="summary-modal-card summary-modal-card-main">
              <span className="summary-modal-card-title">Total Practices</span>
              <span className="summary-modal-card-value">{summary.total_practices}</span>
            </div>
            <div className="summary-modal-card">
              <span className="summary-modal-card-title">Total Patients</span>
              <span className="summary-modal-card-value">{summary.total_patients}</span>
            </div>
            <div className="summary-modal-card">
              <span className="summary-modal-card-title">RPM Enrollment</span>
              <span className="summary-modal-card-value">{summary.rpm_patients}</span>
            </div>
          </div>

          <div className="modal-section">
            <div className="modal-section-header">
              <div>
                <FontAwesomeIcon icon={faUsers} className="modal-section-icon" />
                <h4>Current Practices on this page</h4>
              </div>
              <span className="modal-section-note">{practices.length} practice{practices.length === 1 ? '' : 's'} displayed</span>
            </div>
            <div className="practice-list">
              {practices.length > 0 ? (
                practices.map((practice) => (
                  <div key={practice.id} className="practice-list-item">
                    <div className="practice-item-name">{practice.practice_name}</div>
                    <div className="practice-item-meta">
                      <span>{practice.total_patients ?? 0} patients</span>
                      <span>{practice.status || 'Unknown'}</span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="practice-list-empty">No practices loaded for current filters.</div>
              )}
            </div>
          </div>

          <div className="modal-section">
            <div className="modal-section-header">
              <div>
                <FontAwesomeIcon icon={faChartPie} className="modal-section-icon" />
                <h4>Practice summary</h4>
              </div>
            </div>
            <div className="practice-summary-grid">
              <div className="practice-summary-item">
                <span>Total CCM</span>
                <strong>{summary.ccm_patients}</strong>
              </div>
              <div className="practice-summary-item">
                <span>Total PCM</span>
                <strong>{summary.pcm_patients}</strong>
              </div>
              <div className="practice-summary-item">
                <span>Total RTM</span>
                <strong>{summary.rtm_patients}</strong>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-cancel" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default PracticeSummaryModal;
